import { editTsServer } from "../../services/serverApis"
import { useRef } from "react"

const AutoRenewButton = ({ server }) => {
    let debounceTimeout = useRef()
    if (!server) return

    const onChangeHandler = (e) => {
        let checked = e.target.checked
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current)
            debounceTimeout.current = null
        }

        debounceTimeout.current = setTimeout(() => {
            editTsServer({
                serverId: server.id,
                autorenew: checked,
            })
        }, 500)
    }

    return (
        <div className="flex my-1" dir="rtl">
            <label class="relative inline-flex items-center cursor-pointer">
                <input
                    onChange={onChangeHandler}
                    type="checkbox"
                    name="autorenew"
                    class="sr-only peer"
                    defaultChecked={server.autorenew}
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </label>
        </div>
    )
}

export default AutoRenewButton
